import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CultureSharedService } from '../_services/culture.shared.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  currentLang: string;

  constructor(private cultureSharedService: CultureSharedService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // if (this.skipHandling(request)) {
    //   return next.handle(request);
    // }
    request = request.clone({
      url: request.url.includes('api/ecom/processlinkedcard')
        ? `${environment.merchantApiUrl}/${request.url}`
        : request.url.includes('api/p2p/transfer/getavailablecountrieslist')
        ? `${environment.apiP2P}/${request.url}`
        : `${environment.apiUrl}/${request.url}`,
      setHeaders: {
        'Accept-Language': this.getLanguage() ?? 'ru',
      },
    });

    return next.handle(request);
  }

  private skipHandling(request: HttpRequest<any>) {
    return request.url.includes('/content/gettranslates/');
  }

  private getLanguage(): string {
    this.cultureSharedService.currentLang$.subscribe({
      next: (lang) => {
        if (!!lang) {
          this.currentLang = lang;
        }
      },
    });
    return this.currentLang;
  }
}
